import { dataUserBookmarkSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserBookmarkSolid = /*#__PURE__*/createIcon(dataUserBookmarkSolid)
export default IconUserBookmarkSolid
